import { Grid } from "@mui/material";
import styled from "styled-components";
import { Fragment, useEffect, useState } from "react";
import { DesktopDatePicker as MUIDesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

import { Mandatory } from "../FormOne";
import { colors } from "../../../css components/Style";

const DesktopDatePicker = styled(MUIDesktopDatePicker)`
  .MuiTextField-root {
    padding: 8px;
    border-color: #909090 !important;
  }

  & label.Mui-focused {
    color: ${colors.purple};
  }

  & .MuiOutlinedInput-root {
    &.Mui-focused fieldset {
      border-color: ${colors.purple};
    }
  }

  .MuiInputLabel-root {
    color: #333;
  }

  .MuiOutlinedInput-notchedOutline {
    border-radius: 5px;
  }

  .MuiOutlinedInput-root {
    font-size: 16px;
    border-color: ${colors.purple};
    border-radius: 5px;
  }

  .Mui-disabled {
    color: rgba(0, 0, 0, 0.66);
    font-size: 16px;
    border-radius: 5px;
    -webkit-text-fill-color: rgba(0, 0, 0, 0.66);
  }

  .MuiInputLabel-outlined {
    font-size: 16px;
  }

  .Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: #f5f5f5;
    border: 1px solid #c4cacb;
  }

  #mui-7-helper-text {
    color: red;
  }
  .MuiInputLabel-asterisk {
    color: ${(props) => (Boolean(props.required && !props.value) ? "red" : "")};
  }
`;

export default function DatePicker({
  dispatch,
  state,
  field,
  editState,
  formikProps,
}) {
  const [inputValue, setInputValue] = useState({});

  useEffect(() => {
    if (state[field.name]) {
      setInputValue((prev) => ({
        ...prev,
        [field.name]: state[field.name],
      }));
    }
  }, [state, field.name]);

  return (
    <Fragment>
      <Grid size={6}>
        <Mandatory
          dispatch={dispatch}
          state={state}
          editState={editState}
          field={field}
          formikProps={formikProps}
        />

        <DesktopDatePicker
          sx={{ width: "100%" }}
          label={field.label}
          name={`${field.name}.value`}
          disabled={!editState}
          value={inputValue[field.name]?.value || null}
          slotProps={{
            textField: {
              size: "small",
            },
          }}
          onChange={(newValue) => {
            let date = new Date(newValue);

            if ((date.getFullYear() + "").length < 3) {
              return setInputValue((prev) => ({
                ...prev,
                [field.name]: { value: null },
              }));
            }

            let d =
              date.getFullYear() +
              "-" +
              (date.getMonth() + 1 < 10
                ? "0" + (date.getMonth() + 1)
                : date.getMonth() + 1) +
              "-" +
              date.getDate();

            handleDate(d, field.name, "value");

            return setInputValue((prev) => ({
              ...prev,
              [field.name]: { value: d },
            }));
          }}
        />
      </Grid>
    </Fragment>
  );

  function handleDate(value, name, key) {
    dispatch({
      type: "UPDATE_FIELD",
      formikProps: formikProps,
      payload: { value, name, key },
    });
  }
}
